// Set REACT_APP_API_URL to override, e.g.:
//   REACT_APP_API_URL=https://beetweet-backend.wassimalahmad.online npm run build
// Defaults to the production backend.
const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://beetweet-backend.wassimalahmad.online';

export const API = {
  baseUrl: API_BASE_URL,
  socketUrl: API_BASE_URL,
  register: `${API_BASE_URL}/api/auth/register`,
  login: `${API_BASE_URL}/api/auth/login`,
  usersMe: `${API_BASE_URL}/api/users/me`,
  usersSearch: `${API_BASE_URL}/api/users/search`,
  users: `${API_BASE_URL}/api/users`,
  conversations: `${API_BASE_URL}/api/conversations`,
  upload: `${API_BASE_URL}/api/upload`,
  fcmToken: `${API_BASE_URL}/api/users/fcm-token`,
};
